import { render, staticRenderFns } from "./handover.vue?vue&type=template&id=1daba78e&scoped=true"
import script from "./handover.vue?vue&type=script&lang=js"
export * from "./handover.vue?vue&type=script&lang=js"
import style0 from "./handover.vue?vue&type=style&index=0&id=1daba78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daba78e",
  null
  
)

export default component.exports